<template>
  <div>
    <div class="img-wrap" v-for="(item,index) in data" :key="index">
      <!-- @aigc:start 2024/12/02-15:48 -->
      <div class="img-wrap__img-box" v-fastclick="() => handleImage(item)">
        <img
          class="img-wrap__img"
          v-if="item.imgUrl"
          :src="item.imgUrl"
          @load="loadImgHandle(index)"
        />
        <div class="img-wrap__img-box-mask"></div>
      </div>
      <!-- @aigc:end 2024/12/02-15:48 -->

      <video
        controls="controls"
        v-if="item.videoUrl"
        :src="item.videoUrl"
        :poster="item.coverUrl"
        preload="auto"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x-webkit-airplay="true"
        webkit-playsinline="true"
        playsinline="true"
        x5-playsinline="true"
        style="object-fit:fill;float: left;"
      />
      <div style="clear: both;"></div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { env } from '@utils';

export default {
  name: 'CourseResource',
  props: {
    data: {
      type: [Array, Object],
      default: () => []
    }
  },
  methods: {
    loadImgHandle(index) {
      this.$emit('loadImage', index);
    },
    splitIgcfrom(url) {
      if (!url) { return url }
      let arr = url.split('?');
      const igcFrom = this.$route.query.igc_from;
      if (arr.length > 1) {
        !arr[1].includes('igc_from') && (url += '&igc_from=' + igcFrom);
      } else {
        url += '?igc_from=' + igcFrom;
      }
      return url;
    },

    handleImage(item) {
      // 新的数据结构 clickType 0: 无 101: 超链接 102: 设置购买 1:跳转商品 2: 跳转拼团 3:跳转小货架 103:显示大图
      if (item.type === 'button' || item.clickType === '102') {
        this.$emit('onImage', { action: 'buy' });

      } else if ((item.imgHyperLink && !item.clickType) || item.clickType === '101') {
        this.$emit('onImage', { action: 'jump', url: this.splitIgcfrom(item.imgHyperLink) });

      } else if (['1', '2'].includes(item.clickType) && item.imgHyperLink) {
        this.$emit('onImage', { action: 'jump', url: this.splitIgcfrom(`/mall/course${item.imgHyperLink}`) });

      } else if (item.clickType === '3' && item.imgHyperLink) {
        this.$emit('onImage', { action: 'jump', url: this.splitIgcfrom(`/mall/shoppingPolymerize${item.imgHyperLink}`) });

      } else if (item.clickType === '103' && item.bigImage) {
        if (env.isWeChat) {
          WeixinJSBridge.invoke('imagePreview', {
            'urls': [item.bigImage]
          });
        } else {
          ImagePreview({
            images: [item.bigImage],
            showIndex: false,
            closeable: true
          });
        }
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.img-wrap {
  img {
    width: 100%;
    vertical-align: top;
  }


  video {
    width: 100%;
  }

  &__img {
    // @aigc:start 2024/12/02-15:48
    &-box {
      position: relative;
    }

    &-box-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    // @aigc:end 2024/12/02-15:48
  }
}
</style>